// This component was copied from Anon and transformed into functional component with some cleanups
import React, { useState, useEffect } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

interface Props {
  password: string;
  label: string;
  validPasswordCallback: (errors: any) => void;
  passwordCallback: (value: string) => void;
}

function PasswordTextField({ password, label, validPasswordCallback, passwordCallback }: Props) {
  const classes = useStyles();
  const [hasBlurredOnce, setHasBlurredOnce] = useState(false);

  useEffect(() => {
    if (password.length === 0) {
      setHasBlurredOnce(false);
    }
    validPasswordCallback(displayErrors().length === 0 && password.length !== 0);
  }, [password, validPasswordCallback]);

  const handlePasswordChange = (event: any) => {
    passwordCallback(event.target.value);
  };

  const toggleBlurredOnce = () => {
    setHasBlurredOnce(true);
  };

  const displayErrors = () => {
    let errorMessages = [];
    const errors = [
      {
        msg: 'Please add at least one lowercase letter.',
        regex: /[a-z]/,
      },
      {
        msg: 'Please add at least one capital letter.',
        regex: /[A-Z]/,
      },
      {
        msg: 'Please add at least one number.',
        regex: /[0-9]/,
      },
      {
        msg: 'Please add at least eight characters',
        regex: /.{8,}/g,
      },
    ];
    for (let i = 0; i < errors.length; i++) {
      let error = errors[i];
      if (error.regex.test(password) === false && password.length > 0) {
        errorMessages.push(error.msg);
      }
    }
    return errorMessages;
  };

  const displayErrorText = () => {
    const errors = displayErrors();
    const blank = '';
    if (hasBlurredOnce && password.length > 0) {
      return (
        <div className={classes.helperTextContainer}>
          <FormHelperText classes={{ root: classes.root }} error>
            {errors[0]}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {errors[1]}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {errors[2]}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {errors[3]}
          </FormHelperText>
        </div>
      );
    } else {
      return (
        <div className={classes.helperTextContainer}>
          <FormHelperText classes={{ root: classes.root }} error>
            {blank}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {blank}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {blank}
          </FormHelperText>
          <FormHelperText classes={{ root: classes.root }} error>
            {blank}
          </FormHelperText>
        </div>
      );
    }
  };

  const isInvalidPassword = () => {
    return displayErrors().length !== 0 && password.length !== 0 && hasBlurredOnce;
  };

  return (
    <div>
      <FormControl className={classes.input}>
        <InputLabel className={classes.labelSize}>{label}</InputLabel>
        <Input
          className={classes.inputSize}
          type="password"
          onChange={handlePasswordChange}
          value={password}
          onBlur={toggleBlurredOnce}
          error={isInvalidPassword()}
        />
      </FormControl>
      {displayErrorText()}
    </div>
  );
}

const useStyles = makeStyles((theme: any) => {
  return {
    input: {
      width: '100%',
    },
    labelSize: {
      fontSize: 25,
      paddingTop: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        fontSize: 20,
        marginTop: theme.spacing(1),
      },
    },
    inputSize: {
      fontSize: 28,
      minHeight: 70,
      paddingTop: theme.spacing(1),
    },
    root: {
      marginTop: 0,
      fontSize: 15,
    },
    helperTextContainer: {
      marginTop: theme.spacing(0.5),
    },
  };
});

export default PasswordTextField;
